/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowDUturnLeftUpIcon24Regular = forwardRef('ArrowDUturnLeftUpIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M.762 9.152a.875.875 0 0 0 1.276 1.196L6.125 5.99V13a7.875 7.875 0 1 0 15.75 0V7a.875.875 0 1 0-1.75 0v6a6.125 6.125 0 1 1-12.25 0V5.937l4.137 4.412a.875.875 0 0 0 1.276-1.197L8.758 4.32c-.939-1.001-2.527-1.001-3.466 0L.762 9.152Z" })));
});
